import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-app-parametre',
  templateUrl: './parametre.component.html',
  styleUrls: ['./parametre.component.scss']
})
export class ParametreComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
